import { WithdrawalItem } from '@libs/api-reference';
import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../requests';

type UseDeleteWithdrawalOptions = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onReject?: UseMutationConfig<{}>['onReject'];
  // eslint-disable-next-line @typescript-eslint/ban-types
  onSuccess?: UseMutationConfig<{}>['onSuccess'];
};

export default function useDeleteWithdrawalQuery({
  onReject,
  onSuccess,
}: UseDeleteWithdrawalOptions) {
  const {
    execute: deleteWithdrawal,
    isPending: isLoadingDeleteWithdrawal,
    ...query
  } = useMutation(
    ({ withdrawal }: { withdrawal: WithdrawalItem }) =>
      API.deleteWithdrawal(withdrawal.requestId),
    {
      onReject,
      onSuccess,
    }
  );

  return { deleteWithdrawal, isLoadingDeleteWithdrawal, ...query };
}
